<script setup lang="ts">
	const $props = defineProps<{
		id: string
		hoverColorCls?: string,
		txtColorCls?: string
	}>()

	const rConf = useRuntimeConfig()

	const obj = ref({})
	let apiUrl = computed(() => `/rest/article?article=${$props.id}`)
	let cacheKey = computed(() => `article-id-${$props.id}`)

 	const cachedObj = useNuxtData(cacheKey.value)
	if (cachedObj.data.value) {
		obj.value = cachedObj.data.value
	} else {
		const { data } = await useFetch(apiUrl.value, {
			baseURL: rConf.public.apiBase,
			query: { is_active: true },
			key: cacheKey.value
		})
		obj.value = data.value
	}
</script>

<template>
	<div v-if="obj">
		<template v-if="obj.link_groups_display?.length">
			<div v-if="obj.link_groups_display[0].items?.length" class="flex flex-col gap-2.5">
				<NuxtLink v-for="(o,idx) in obj.link_groups_display[0].items" :key="idx" :to="'/' + o.url" class="flex flex-row space-x-2 ms-3 lg:[&_span]:text-[1.125rem] xl:[&_span]:text-[1.25rem] group transition duration-300 ease-in-out" :class="hoverColorCls" :title="o.title" no-prefetch>
					<GsIcon name="bitcoin-icons:arrow-right-outline" class="flex-none my-auto size-5 xl:size-6" :class="txtColorCls" />
					<span class="my-auto sm:whitespace-nowrap group-hover:ms-2 transition-all duration-300 ease-in-out">{{ o.title }}</span>
				</NuxtLink>
			</div>
		</template>
	</div>
</template>
